import { createRoute } from '@tanstack/react-router';
import { layoutRoute } from '@/router/root-routes.tsx';
import { AppBreadcrumbs } from '@/components/app/app-breadcrumbs.tsx';
import { usePageProps } from '@/hooks/use-page-props.ts';

export const aboutRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/about',
  component: AboutPage,
});

export function AboutPage() {
  usePageProps({
    title: 'About Us'
  })
  return (
    <>
      <video
        autoPlay
        muted
        loop
        width="1280"
        height="720"
        playsInline
        poster="/media/home/poster.svg"
        src="https://sacco-public.s3.us-east-1.amazonaws.com/About_Video_2mbps.mp4"
        className="w-full h-auto block mx-auto"
      ></video>
      <div className="max-w-8xl mx-auto">
        <AppBreadcrumbs items={[{ text: 'Home', href: '/' }, { text: 'About' }]} />
        <h1 className="uppercase text-center font-medium mb-8">About Us</h1>
        <p className="text-xl max-w-7xl mx-auto text-center px-4 mb-12 xl:mb-24">
          Sacco Carpet was founded in 2001 by Marc and Debra Sacco on the principle of producing the highest quality
          carpets for the world’s leading interior designers and architects. Sacco’s reputation for excellence and
          quality grew fiercely when Marc developed Sacco’s Chinese Persian knotted silk collection and South African
          hand-woven mohair collection, both colored by the famous John Saladino. It was designers like John Saladino,
          Charlotte Moss and Joe Nahem who caught sight of these collections, earning Sacco a fine reputation for
          excellent products in high-end residential spaces.
        </p>
        <div className="grid lg:grid-cols-2">
          <div
            className="h-[500px] min-h-full"
            style={{
              backgroundImage: "url('/media/about-us-1.jpg')",
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
              backgroundRepeat: 'no-repeat',
            }}
          ></div>
          <div className="flex flex-col justify-center px-4 sm:px-12 xl:px-24 py-12">
            <p className="text-xl leading-7">
              <b>In 2001,</b> Adam Tihany visited the Sacco showroom on a hunt to design the Michelin Star restaurant,
              Perse. Collaborating with Tihany on Perse opened up a world of opportunity for Sacco including; The
              Breakers, Palm Beach, The Mandarin Oriental, Hong Kong and Restaurant Daniel, on Park Avenue. The
              hospitality greats soon followed with David Rockwell, Yabu Pushelberg, Jeffrey Beers and Toni Chi, who
              took Sacco to unforeseen heights. To meet the expectation and demand, Sacco hired the most talented
              artists in the industry and never sacrificed quality for price.
            </p>
          </div>
        </div>
        <div className="grid lg:grid-cols-2">
          <div
            className="h-[500px] min-h-full lg:order-2"
            style={{
              backgroundImage: "url('/media/about-us-2.jpg')",
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
              backgroundRepeat: 'no-repeat',
            }}
          ></div>
          <div className="flex flex-col justify-center px-4 sm:px-12 xl:px-24 py-12">
            <p className="text-xl leading-7">
              <b>Today</b> our business is an equal divided between our residential and hospitality markets. Whether it
              is a 100% silk hand knotted rug, or a New Zealand wool Axminster, Sacco takes every detail into
              consideration, focusing on quality, color, price effectiveness and longevity. Sacco’s devoted sales team
              is enthusiastic, passionate and responsive, proving all the difference in customer service. We have
              successfully opened a showroom in New York and London. We currently have sales reps in Chicago, Texas,
              Florida and Los Angeles.
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center gap-8 my-12 lg:my-24">
          <img className="w-32" src="/media/logo-black-symbol.svg" alt="logo" />
          <h2 className="text-2xl lg:text-4xl">We look forward to serving you.</h2>
        </div>
      </div>
    </>
  );
}
